<template>
  <div class="select" :class="{ InnerMargin0: mOptions.padd == 'top,bottom' }">
    <ul class="select-label">
      <li class="select-label-text">{{ label }}</li>
    </ul>
    <div class="select-body">
      <el-select v-model="mValue" multiple collapse-tags size="mini" :placeholder="mOptions.placeholder" popper-class="role-select-dropdown">
        <el-option v-for="item in project.roleList" :key="item.sign" :label="item.name" :value="item.sign">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import schemaMixin from "@/mixin/schemaMixin";

export default {
  name: "SchemaRoleSelect",

  mixins: [schemaMixin],

  provide() {
    return {
      mode: this,
    };
  },
  computed: {
    ...mapGetters(["project"]),
  },

  inject: ['mode'],

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.InnerMargin0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.select {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #fff;

  .select-label {
    display: flex;
    align-items: center;

    .select-label-text {
      width: 80px;
      color: #969799;
      font-size: 13px;
    }
  }

  .select-body {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    min-width: 0;

    ::v-deep .el-select {
      width: 100%;

      .el-select__tags {
        max-width: 100% !important;
        flex-wrap: nowrap;
        overflow: hidden;
      }
    }
  }
}

.mode-select {
  display: flex;
  justify-content: space-between;

  .mode-select-label {
    font-size: 14px;
    /*no*/
    line-height: 32px;
    /*no*/
  }

  .mode-select-body {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>

<style lang="scss">
.role-select-dropdown {
  max-height: 300px;
  overflow-y: auto;
}
</style>
